import { render, staticRenderFns } from "./AbnormalAbnormal.vue?vue&type=template&id=2cdfff0e&scoped=true&"
import script from "./AbnormalAbnormal.vue?vue&type=script&lang=js&"
export * from "./AbnormalAbnormal.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalAbnormal.vue?vue&type=style&index=0&id=2cdfff0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdfff0e",
  null
  
)

export default component.exports